import { useEffect, useState } from 'react';
import { CapacitorUpdater } from '@capgo/capacitor-updater';
import { useCapgoUpdater } from '@/hooks';
import { logger } from '@/lib/logger';
export const useCapgoUpdates = () => {
  const { updateState, resetUpdateState } = useCapgoUpdater();
  const [isUpdatesReady, setIsUpdatesReady] = useState(false);

  // Silently handle transient update states
  useEffect(() => {
    if (updateState.status === 'updateAvailable' || updateState.status === 'appReloaded') {
      resetUpdateState();
    }
  }, [updateState, resetUpdateState]);

  // Notify Capgo that the app is ready (only once, after loading is done)
  useEffect(() => {
    try {
      CapacitorUpdater.notifyAppReady();
      setIsUpdatesReady(true);
    } catch (error) {
      logger.error('Capgo updates setup failed', { error, component: 'useCapgoUpdates' });
      setIsUpdatesReady(true); // Still mark as ready to not block app
    }
  }, []);

  return { isUpdatesReady, updateState, resetUpdateState };
}; 